import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BoxQuotaData } from '../../model/box.quote.data';
import { DailyOpenService } from '../../services/daily-open/daily-open.service';
import { map, combineLatest } from 'rxjs/operators';
import { Subscription, Observable, zip, forkJoin, of } from 'rxjs';

@Component({
  selector: 'small-box',
  template: require('./small-box.component.html'),
  styles: [require('./small-box.component.scss')]
})
export class SmallBoxComponent implements OnInit, OnDestroy 
{
  private _item!: BoxQuotaData;
  public get item()
  {
    return this._item;
  }

  @Input('item') 
  public set item(value: BoxQuotaData)
  {
    this._item = value;
    this.subscribeDailyOpen();
    value.sendAsk();
  }

  public quota!: number;
  
  private _dailyOpenSubscription?: Subscription;
  private _dailyOpenRefreshInterval?: number;

  constructor(private dailyOpenService: DailyOpenService) 
  {
  }

  ngOnInit() 
  {
  }

  ngOnDestroy ()
  {
    this.unsubscribeDailyOpen();
  }

  subscribeDailyOpen()
  {
    this.unsubscribeDailyOpen();
    let dailyOpenResponse = this.dailyOpenService.getDailyOpen(this.item.Symbol);
    
    this._dailyOpenRefreshInterval = dailyOpenResponse.sendRequestInterval;
    this._dailyOpenSubscription = dailyOpenResponse.dailyOpenObservable
    .pipe(map(r => (r || 0)))
    .pipe(combineLatest(this.item.askSubject))
    .subscribe(latest =>
    {
      this.quota = latest[1]-latest[0];
    })
  }
  unsubscribeDailyOpen()
  {
    if(this._dailyOpenSubscription) this._dailyOpenSubscription.unsubscribe();
    if(this._dailyOpenRefreshInterval) clearInterval(this._dailyOpenRefreshInterval);
  }
}
